module.exports = __webpack_public_path__ + "static/media/all.381df028.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/inviteNew/all.png
// module id = 1928
// module chunks = 6